import { initializeApp } from "firebase/app";
import { GoogleAuthProvider, getAuth } from "firebase/auth";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDWq6lHgZtxIsQJwCv9WN56EnwQRcfM164",
  authDomain: "edaya-guestapp.firebaseapp.com",
  projectId: "edaya-guestapp",
  storageBucket: "edaya-guestapp.firebasestorage.app",
  messagingSenderId: "711017429666",
  appId: "1:711017429666:web:19aa0f2e39c596774575fb",
  measurementId: "G-4S32M60S8T",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth();
export const googleAuthProvider = new GoogleAuthProvider();

export default app;

export const messaging = getMessaging(app);
